import { OilTankerIcon } from './OilTankerIcon';

export const LITERS_PER_TRUCK = 30000;

export function litersToTruckCount(liters) {
  const n = Number(liters);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.round(n / LITERS_PER_TRUCK);
}

/**
 * Shows saved liters as oil-tanker count (1 truck = 30 000 L), e.g. "7 × tanker".
 */
export function BloodyLitersTrucks({ liters, className = '' }) {
  const truckCount = litersToTruckCount(liters);

  return (
    <span
      className={`bloody-liters-trucks ${className}`.trim()}
      title={Number.isFinite(Number(liters)) ? `${Number(liters).toLocaleString()} L` : undefined}
    >
      <span className="bloody-liters-trucks__count">{truckCount}</span>
      <span className="bloody-liters-trucks__times" aria-hidden>
        ×
      </span>
      <OilTankerIcon className="bloody-liters-trucks__icon" />
    </span>
  );
}
